import { PageTitle } from "@/components/shared/title/page-title";
import * as React from "react";
import { WorkerTypes } from "./WorkerTypesPage";
import { WorkerTypesProvider } from "./context/WorkerTypesContext";

type Props = {};

const WorkerTypesPage = (props: Props) => {
	return (
		<>
			<PageTitle title="Worker Types Management" />
			<WorkerTypesProvider>
				<WorkerTypes />
			</WorkerTypesProvider>
		</>
	);
};

export default WorkerTypesPage;
